const blockingScrollObject = {
    header: null,
    numberScrollTop: 0,
    status: -1,
    scrollWidth: 0,
    initialize: function () {
        if (this.status === 1) return;
        this.status = 1;

        this.header = document.querySelector('.header-container');

        let div = document.createElement('div');

        div.style.overflowY = 'scroll';
        div.style.width = '50px';
        div.style.height = '50px';

        document.body.append(div);
        this.scrollWidth = div.offsetWidth - div.clientWidth;

        div.remove();
    },
    start: function () {
        this.numberScrollTop = window.pageYOffset;
        const windowWidth = document.body.clientWidth;
        const headerWidth = this.header.clientWidth;

        document.body.style.cssText = 'position: fixed; top: -' + this.numberScrollTop +
            'px; left: 0; overflow: hidden; height: 100%; width: ' + windowWidth + 'px';

        if (this.scrollWidth) {
            //document.body.style.paddingRight = this.scrollWidth + 'px';
            this.header.style.cssText = 'width: ' + headerWidth + 'px';
        }
    },
    stop: function (delay) {
        if (!delay) delay = 200;
        setTimeout(function () {
            document.body.setAttribute('style', '');
            this.header.setAttribute('style', '');
            window.scrollTo(0, this.numberScrollTop);
        }.bind(this), delay);
    }
}
